import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  insuranceList,
  createInsurance,
  updateInsurance,
  deleteInsurance,
} from "app/services/insurance/insuranceService";
import { fetchBenchmarkPatientInsurance } from "app/services/transmission/patient";
import { BASE_URL } from "static/constants";

export const insuranceApi = createApi({
  reducerPath: "insuranceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["insurances"],
  endpoints: ({ query, mutation }) => ({
    getInsurances: query({
      queryFn: () => {
        return { data: insuranceList() };
      },
      providesTags: ["insurances"],
    }),
    createInsurance: mutation({
      queryFn: (payload) => {
        return { data: createInsurance(payload) };
      },
      invalidatesTags: ["insurances"],
    }),
    updateInsurance: mutation({
      queryFn: ({ id, payload }) => {
        return { data: updateInsurance(id, payload) };
      },
      invalidatesTags: ["insurances"],
    }),
    deleteInsurance: mutation({
      queryFn: (id) => {
        return { data: deleteInsurance(id) };
      },
      invalidatesTags: ["insurances"],
    }),
    getBenchmarkInsurances: query({
      queryFn: async ({ benchmarkId, evokeId }) => {
        const response = await fetchBenchmarkPatientInsurance(
          benchmarkId,
          evokeId
        );
        return { data: response };
      },
    }),
  }),
});

export const {
  useGetInsurancesQuery,
  useGetBenchmarkInsurancesQuery,
  useCreateInsuranceMutation,
  useUpdateInsuranceMutation,
  useDeleteInsuranceMutation,
} = insuranceApi;
